import { useEffect } from 'react';
import { Outlet, useNavigate, useLocation, useParams } from 'react-router-dom';
import Forbidden from '../Pages/Forbidden';

const PrivateRoutes = ({ allowedRoles }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const token = localStorage.getItem('token');
  const role = localStorage.getItem('Role');
  const rolewiseId = localStorage.getItem('currentRestId');
  const { slug2, wine_list_name, menu_id, beverage_id } = useParams();

  const isAuthenticated = !!token;
  const isAuthorized = allowedRoles ? allowedRoles.includes(role) : true;

  // console.log(isAuthorized, "isAuthorized", isAuthenticated, "isAuthenticated")

  useEffect(() => {
    if (isAuthenticated) {
      const adminRoutes = [
        `/admin/dashboard`,
        `/admin/wine`,
        `/admin/restaurantManagement`,
        `/admin/restaurantManagement/${slug2}`,
        `/admin/wineStock/${slug2}`,
        `/admin/userManagement`,
        `/admin/user-add`,
        `/admin/userRole`,
        `/admin/settings`,
        `/admin/changePassword`,
        `/admin/orderManagement`,
        `/admin/allergensManagement`,


        //===================== admin access for restaurant ===============

        `/restaurantPanel/dashboard/${rolewiseId}`,
        `/restaurantPanel/viewStock/${rolewiseId}`,
        `/restaurantPanel/decreaseStock/${rolewiseId}`,
        `/restaurantPanel/incomingOrder/${rolewiseId}`,
        `/restaurantPanel/pastOrder/${rolewiseId}`,
        `/restaurantPanel/restaurant-user/${rolewiseId}`,
        `/restaurantPanel/restaurant-user-add/${rolewiseId}`,
        `/restaurantPanel/restaurantManagement/${rolewiseId}`,
        `/restaurantPanel/userRole/${rolewiseId}`,
        `/restaurantPanel/dishManagement/${rolewiseId}`,
        `/restaurantPanel/menuManagement/${rolewiseId}`,
        `/restaurantPanel/wineFood/${rolewiseId}`,
        `/restaurantPanel/beverageManagement/${rolewiseId}`,
        `/restaurantPanel/courseManagement/${rolewiseId}`,
        `/restaurantPanel/categoryManagement/${rolewiseId}`,
        `/wine_list_pdf/${wine_list_name}`,
        `/menu_list_pdf/${menu_id}`,
        `/beverage_list_pdf/${beverage_id}`
      ];

      const restaurantOwnerRoutes = [
        `/restaurantPanel/dashboard/${rolewiseId}`,
        `/restaurantPanel/viewStock/${rolewiseId}`,
        `/restaurantPanel/decreaseStock/${rolewiseId}`,
        `/restaurantPanel/incomingOrder/${rolewiseId}`,
        `/restaurantPanel/pastOrder/${rolewiseId}`,
        `/restaurantPanel/restaurant-user/${rolewiseId}`,
        `/restaurantPanel/restaurant-user-add/${rolewiseId}`,
        `/restaurantPanel/restaurantManagement/${rolewiseId}`,
        `/restaurantPanel/userRole/${rolewiseId}`,
        `/restaurantPanel/settings/${rolewiseId}`,
        `/restaurantPanel/settingsDetail/${rolewiseId}`,
        `/restaurantPanel/changePassword/${rolewiseId}`,
        `/restaurantPanel/dishManagement/${rolewiseId}`,
        `/restaurantPanel/menuManagement/${rolewiseId}`,
        `/restaurantPanel/wineFood/${rolewiseId}`,
        `/restaurantPanel/beverageManagement/${rolewiseId}`,
        `/restaurantPanel/courseManagement/${rolewiseId}`,
        `/restaurantPanel/categoryManagement/${rolewiseId}`,
        `/wine_list_pdf/${wine_list_name}`,
        `/menu_list_pdf/${menu_id}`,
        `/beverage_list_pdf/${beverage_id}`
      ];

      const currentPath = location.pathname;

      if (role === 'admin' && adminRoutes.includes(currentPath)) {
        return;
      } else if (role === 'restaurant' && restaurantOwnerRoutes.includes(currentPath)) {
        return;
      } else if (role === 'admin') {
        navigate('/admin/dashboard');
      } else if (role === 'restaurant') {
        navigate(`/restaurantPanel/dashboard/${rolewiseId}`);
      }
    } else {
      localStorage.removeItem('Role');
      localStorage.removeItem('token');
      localStorage.removeItem('currentRestId');
      localStorage.removeItem("loginUserId");
      localStorage.removeItem('type');
      localStorage.removeItem('RoleName');
      localStorage.removeItem('RoleId');
      navigate('/admin/login');
    }
  }, [isAuthenticated, isAuthorized, role, rolewiseId, navigate, location]);

  return isAuthenticated && isAuthorized ? <Outlet /> : <Forbidden />;
};

export default PrivateRoutes;